module.exports = __webpack_public_path__ + "img/times-up.5cbd5b65.png";